














































import {defineComponent} from "@vue/composition-api"
import UserInfo from "@/components/layout/UserInfo.vue"

export default defineComponent({
  components: {UserInfo},
})
